import { authHeaders } from '../../utils/authHeaders';

/** Session token plus the active organization and site, the same headers the desktop app sends. */
export function scopeHeaders(token) {
  let locationId = '';
  try { locationId = localStorage.getItem('current_location_id') || ''; } catch { /* storage off */ }
  return authHeaders({ token, locationId });
}
